import { Text } from '@chakra-ui/react';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';

import { assetsUri } from '@/services/api.service';
import { getFinanceFilterBanner } from '@/services/pages/pages.service';

import styles from './price-filter-promo.module.scss';

export const PriceFilterPromo = () => {
  const [pageInfo, setPageInfo] = useState({
    image: '',
    title: '',
    description: '',
    button_text: '',
    url: '',
  });

  useEffect(() => {
    (async function () {
      try {
        const content = await getFinanceFilterBanner();

        setPageInfo(content);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  return (
    <div className={styles.priceFilterPromo}>
      <div className={styles.promoImage}>
        { pageInfo.image && <Image src={`${assetsUri}/${pageInfo.image}`} alt={pageInfo.title} width={386} height={253} /> }
      </div>
      <div className={styles.promoWrapper}>
        <article className={styles.priceFilterPromoArticle}>
          <Text className={styles.priceFilterPromoArticleTitle}>
            {pageInfo.title}
          </Text>
          <Text>{pageInfo.description}</Text>
        </article>
        <a className={styles.priceFilterPromoButton} href={pageInfo.url}>
          {pageInfo.button_text}
        </a>
      </div>
    </div>
  );
};
